angular.module('lf.desktop')

.directive('bindPopover', function (popoversService) {
  return function (scope, el, attrs) {
    popoversService.bindPopover(attrs.bindPopover, {el: el});
  }
});